<template>
    <div :class="['user-initials', currentColor]">
        {{ initials }}
    </div>
</template>

<script setup lang="ts">
    import { computed, defineProps, toRefs } from "vue";
    import store from "@/store";
    const colors = {
        default: "default",
        grey: "grey",
        purple: "purple",
        orange: "orange",
        green: "green",
    };

    const props = withDefaults(
        defineProps<{
            color?: keyof typeof colors;
            indexColor?: number;
        }>(),
        {}
    );

    const initials = computed(() => store.getters["userData/initials"]);
    const profiles = computed(() => store.getters["userData/activeProfiles"]);
    const currentProfile = computed(() => store.getters["userData/currentProfile"]);
    const { color, indexColor } = toRefs(props);
    const currentColor = computed(() => {
        if (color?.value) {
            return color.value;
        }

        const colorNames = Object.keys(colors);

        if (typeof indexColor?.value === "number") {
            const index = indexColor.value;

            if (index > 4) {
                return colorNames[4] as keyof typeof colors;
            }

            return colorNames[index] as keyof typeof colors;
        }

        if (profiles?.value && currentProfile?.value) {
            const profileIndex = profiles.value.findIndex((profile: any) => profile.pk === currentProfile.value.pk);

            if (profileIndex > -1) {
                return colorNames[profileIndex] as keyof typeof colors;
            }
        }

        return "default";
    });
</script>

<style lang="scss" scoped>
    @import "@/style/variables";

    .user-initials {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        display: grid;
        place-items: center;
        color: $color-light;

        &.default {
            background-color: $color-default-blue;
        }

        &.grey {
            background-color: $color-text-dark;
        }

        &.purple {
            background-color: $color-default-purple;
        }

        &.orange {
            background-color: $color-default-orange;
        }

        &.green {
            background-color: $color-default-green;
        }
    }
</style>
